import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {AssessmentAttempt} from '../models/assessment/assessment-attempt.model';
import {createReducer, on} from '@ngrx/store';
import {AssessmentAttemptActions} from './action-types';

export interface AssessmentAttemptsState extends EntityState<AssessmentAttempt> {

}

export const adapter: EntityAdapter<AssessmentAttempt> = createEntityAdapter<AssessmentAttempt>();

export const initialState: AssessmentAttemptsState = adapter.getInitialState();

export const assessmentAttemptsReducer = createReducer(
  initialState,
  on(AssessmentAttemptActions.assessmentAttemptCreated, (state,{attempt}) => adapter.addOne(attempt, state)),
  on(AssessmentAttemptActions.loadAssessmentAttemptSuccess, (state, { attempt }) => adapter.addOne(attempt, state)),
  on(AssessmentAttemptActions.loadCourseAssessmentsSuccess, (state, { attempts }) => adapter.addMany(attempts, state)),
);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
